import {
  Row,
  Col,
  Card,
  Radio,
  Table,
  notification,
  Button,
  Input,
  Menu,
  Dropdown,
  Modal
} from "antd";

import { SearchOutlined, DownOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

// Images
import { useEffect, useState } from "react";
import { getBookingById, getBookingsRental, deleteRentalBookings } from "../api/booking.service";
import moment from "moment";
import dayjs from "dayjs";
import EditRentalBookingPackageModal from "../components/forms/rental-booking/EditRentalBookingPackageModal";
import TimerCell from "../components/TimerCell";
import AssignVehicleToBookingModalForm from "../components/forms/airport-booking/AssignVehicleToBookingModalForm";
import AssignVehicleToRentalBookingModalForm from "../components/forms/rental-booking/AssignVehicleToRentalBookingModalForm";
import config from '../config';

function RentalBookings() {

  const [isModalOpenAssign, setIsModalOpenAssign] = useState(false);


  const handlePrintDownload = (record) => {
    const link = `${config.API_URL}/${record.latestPdf}`;
    window.open(link, '_blank');
  };


  const handleEmailTask = (record) => {
    const mailtoLink = `mailto:${record.email}`;
    window.location.href = mailtoLink;
  };

  const handleAssignVehicle = async (record) => {
    const data = await getBookingById(record.referenceNo);
    setVehicleData(data.data);
    setIsModalOpenAssign(true);
  };

  const handleCancelAssign = () => {
    setIsModalOpenAssign(false);
  };

  const handleOkAssign = () => {

  }

  // project table start
  const project = [
    {
      title: "REFERENCE NO",
      dataIndex: "referenceNo",
      width: 100,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Reference No"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record.referenceNo
          ? record.referenceNo.toString().toLowerCase().includes(value.toLowerCase())
          : false,
      render: (text, record) => <div>{record.referenceNo}</div>,
    },
    {
      title: "VEHICLE",
      dataIndex: "selectedVehicle",
      width: 100,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Vehicle"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      // Filter on selectedVehicle.name
      onFilter: (value, record) =>
        record.selectedVehicle && record.selectedVehicle.name
          ? record.selectedVehicle.name.toLowerCase().includes(value.toLowerCase())
          : false,
      render: (text, record) => (
        <div>{record.selectedVehicle ? record.selectedVehicle.name : ""}</div>
      ),
    },
    {
      title: "DATES",
      dataIndex: "dateRange",
      width: 150,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Dates"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) => {
        if (!record.dateRange || record.dateRange.length < 2) return false;
        // Create a string like "01-Jan-2023 to 31-Jan-2023"
        const datesStr =
          dayjs(record.dateRange[0]).format("DD-MMM-YYYY") +
          " to " +
          dayjs(record.dateRange[1]).format("DD-MMM-YYYY");
        return datesStr.toLowerCase().includes(value.toLowerCase());
      },
      render: (text, record) => {
        const dates = record.dateRange.map((date) =>
          dayjs(date).format("DD-MMM-YYYY")
        );
        return <div>{dates[0] + " to " + dates[1]}</div>;
      },
    },
    {
      title: "DAYS",
      dataIndex: "dateRange",
      width: 150,
      render: (text, record) => {
        const startDate = dayjs(record.dateRange[0]);
        const endDate = dayjs(record.dateRange[1]); 
        const diffDays = endDate.diff(startDate, 'day') + 1;
        return <div>{diffDays}</div>;
      },
    },
    {
      title: "ASSIGNED VEHICLE",
      dataIndex: "vehicle",
      width: "15%",
      key: "vehicle",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Vehicle"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record.vehicle && record.vehicle.registrationNo
          ? record.vehicle.registrationNo
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
          : "",
      render: (text, record) => (
        <div className="author-info">
          <div style={{ fontWeight: "bold" }}>
            {`${record?.vehicle?.registrationNo || "N/A"}`}
          </div>
        </div>
      ),
    },
    {
      title: "TIMER (d h m s)",
      key: "timer",
      width: 100,
      render: (text, record) => (
        <TimerCell dateTime={record.dateRange[0]} referenceNo={record.referenceNo} />
      ),
    },
    {
      title: "ACTIONS",
      width: 120,
      render: (text, record) => {
        const menu = (
          <Menu>
            <Menu.Item
              key="print"
              onClick={() => handlePrintDownload(record)}
            >
             View / Download / Print
            </Menu.Item>
            <Menu.Item
              key="edit"
              onClick={() => getVehicleData(record.referenceNo, false)}
            >
              Edit
            </Menu.Item>
            <Menu.Item
              key="email"
              onClick={() => handleEmailTask(record)}
            >
              Email
            </Menu.Item>
            <Menu.Item
              key="assign"
              onClick={() => handleAssignVehicle(record)}
            >
              Assign Vehicle
            </Menu.Item>
          </Menu>
        );
        return (
          <Dropdown overlay={menu}>
            <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
              Tasks <DownOutlined />
            </a>
          </Dropdown>
        );
      },
    },
  ];


  const [bookings, setBookings] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [isModalOpenEdit, setIsModalOpenEdit] = useState(false);
  const [vehicleData, setVehicleData] = useState(null);
  const [isViewOnly, setisViewOnly] = useState(false);
  const [selectedFilter ,setFilter] = useState("all");

  const fetchBookings = async (filter = 'all') => {
    setLoading(true);
    setError(null);
    try {
      const data = await getBookingsRental(filter);
      setBookings(data?.data || []);
      // notification.success({ message: 'Data refreshed' })
    } catch (err) {
      setError('Failed to fetch bookings.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings();
  }, []);

  const getVehicleData = async (id, isViewOnly = false) => {
    setisViewOnly(isViewOnly)
    const data = await getBookingById(id);
    setVehicleData(data.data);
    setIsModalOpenEdit(true);
  }

  useEffect(() => {
    const ws = new WebSocket(process.env.REACT_APP_API_URL.replace('https://', 'wss://').replace('http://', 'ws://')); 

    ws.onopen = () => {
      console.log("Connected to WebSocket server");
    };

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.event === "rental-booking-added") {
        fetchBookings();
      }
    };

    ws.onclose = () => {
      console.log("Disconnected from WebSocket server");
    };

    // Cleanup WebSocket connection on unmount
    return () => {
      ws.close();
    };
  }, []);

  const handleOkEdit = () => {
    setIsModalOpenEdit(false);
  };

  const handleCancelEdit = () => {
    setIsModalOpenEdit(false);
  };

  const onChange = (e) => console.log(`radio checked:${e.target.value}`);

  const onChangeFilter = (e) =>{
    setFilter(e.target.value)
    fetchBookings(e.target.value)
  }

  const handleBulkDelete = async () => {
    if (selectedRowKeys.length === 0) {
      notification.warning({
        message: 'Please select at least one booking to delete'
      });
      return;
    }

    Modal.confirm({
      title: (
        <span style={{ color: '#ff4d4f', fontWeight: 'bold', fontSize: '18px' }}>
          <ExclamationCircleOutlined style={{ marginRight: 8 }} />
          Warning - Permanent Deletion
        </span>
      ),
      icon: <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />,
      content: (
        <div style={{ fontSize: '16px', marginTop: 10 }}>
          <p style={{ fontWeight: 'bold', marginBottom: 10 }}>
            Are you sure you want to permanently delete <strong style={{ color: '#ff4d4f' }}>{selectedRowKeys.length}</strong> rental booking(s)?
          </p>
          <p style={{ color: '#ff4d4f', marginTop: 10 }}>
            ⚠️ This action cannot be undone. All selected bookings will be permanently removed from the database.
          </p>
        </div>
      ),
      okText: "Yes, Delete Permanently",
      okType: "danger",
      cancelText: "Cancel",
      width: 500,
      onOk: async () => {
        try {
          setLoading(true);
          // Convert referenceNos to IDs
          const ids = selectedRowKeys.map(refNo => {
            const booking = bookings.find(b => b.referenceNo === refNo);
            return booking?.id;
          }).filter(id => id !== undefined);
          
          const response = await deleteRentalBookings(ids);
          notification.success({
            message: response.msg || `Successfully deleted ${response.data?.deletedCount || ids.length} rental booking(s)`
          });
          setSelectedRowKeys([]);
          fetchBookings(selectedFilter);
        } catch (error) {
          notification.error({
            message: error?.response?.data?.msg || error?.response?.data?.message || 'Failed to delete rental bookings'
          });
        } finally {
          setLoading(false);
        }
      },
      onCancel() {
        console.log("Bulk delete cancelled");
      },
    });
  }

  return (
    <>
    <div className="ant-filtertabs mb-4">
        <div className="flex justify-end antd-pro-pages-dashboard-analysis-style-salesExtra items-center">
          <Radio.Group onChange={onChangeFilter} defaultValue="all">
            <Radio.Button value="all">ALL</Radio.Button>
            <Radio.Button value="past">PAST</Radio.Button>
            <Radio.Button value="ongoing">ONGOING</Radio.Button>
            <Radio.Button value="upcoming">UPCOMING</Radio.Button>
          </Radio.Group>
        </div>
      </div>
      {vehicleData &&
        <AssignVehicleToRentalBookingModalForm vehicleData={vehicleData} fetchAllVehicles={fetchBookings} handleCancel={handleCancelAssign} handleOk={handleOkAssign} isModalOpen={isModalOpenAssign} setIsModalOpen={setIsModalOpenAssign} />}
      {vehicleData && <EditRentalBookingPackageModal isViewOnly={isViewOnly} vehicleData={vehicleData} fetchVehicles={fetchBookings} handleCancel={handleCancelEdit} handleOk={handleOkEdit} isModalOpen={isModalOpenEdit} setIsModalOpen={setIsModalOpenEdit} />}
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Rental Bookings Table"
              extra={
                selectedRowKeys.length > 0 && (
                  <Button
                    type="primary"
                    danger
                    onClick={handleBulkDelete}
                    loading={loading}
                  >
                    Delete Selected ({selectedRowKeys.length})
                  </Button>
                )
              }
            >
              <div className="table-responsive">
                <Table
                  rowSelection={{
                    type: 'checkbox',
                    selectedRowKeys,
                    onChange: setSelectedRowKeys,
                  }}
                  rowKey="referenceNo"
                  columns={project.filter(col => {
                    // Hide timer column for past and ongoing tabs
                    if (col.key === 'timer') {
                      return !['past', 'ongoing'].includes(selectedFilter);
                    }
                    return true;
                  })}
                  dataSource={bookings}
                  pagination={{
                    pageSize: 100
                  }}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default RentalBookings;
